export default {
  rpc: {},
  types: {
    Multiplier: 'Fixed128'
  }
};